<template>
    <div id="odiv">
        <p class="p1">查看详情</p>
        <div class="del">
            <el-row :gutter="24">
                <el-col :span="6">
                    <div class="grid-content bg-purple">入库单号：
                        <el-input v-model="detailData.id" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="6">
                    <div class="grid-content bg-purple">入库日期：
                        <el-input v-model="detailData.date" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="6">
                    <div class="grid-content bg-purple">供应商：
                        <el-input v-model="detailData.supplier" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="6">
                    <div class="grid-content bg-purple">制单人：
                        <el-input v-model="detailData.username" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">审核日期：
                        <el-input v-model="detailData.reviewDate" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">审核人员：
                        <el-input v-model="detailData.reviewUsername" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple" >备 &nbsp;&nbsp;注：
                        <el-input v-model="detailData.remarks" disabled style="width: 150px"></el-input></div>
                </el-col>
            </el-row>

        </div>

        <el-table :data="itemList" stripe style="width: 98%;margin-left: 18px" row-key="rowkey" :header-cell-style="tableHeaderColor">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="value" label="药品名称" width="200"></el-table-column>
            <!--<el-table-column prop="manufacturer" label="产地"></el-table-column>-->
            <el-table-column prop="unit" label="单位"></el-table-column>
            <el-table-column prop="inNumber" label="数量"></el-table-column>
            <el-table-column prop="retailPrice" label="零售价(￥)"></el-table-column>
            <el-table-column prop="costPrice" label="成本价(￥)"></el-table-column>
            <el-table-column prop="costPriceTotal" label="成本合计(￥)"></el-table-column>
            <el-table-column prop="batchNumber" label="批号"></el-table-column>
            <el-table-column prop="effectiveDates" label="有效期"></el-table-column>
        </el-table>
        <div style="margin: 10px 20px">
            <div style="width: 200px;height: 150px;float: left" v-for="item in url">
                <img :src="item.url" alt="" style="width:  100%;height:  100%" @click="openpic(item.url)">
            </div>
            <el-dialog
                    title="查看图片"
                    :visible.sync="dialogVisible"
                    width="60%"
            >
                <img :src="pic" alt="" style="width:  100%;height:  100%">
            </el-dialog>
        </div>
        <!--<p class="p3">合计：<span>{{all}}</span></p>-->
        <div style="clear: both">
            <el-button :plain="true" type="info" plain @click="back" :style="{margin:'20px 30px'}">返回</el-button>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    #odiv {
        width: 99%;
        height: 700px;
        background-color: white;
    }
    .input {
        width: 70px;
    }

    .del {
        padding-left: 18px;
        width: 100%;
        color:#95b2d4;
        line-height: 65px;
        font-family: 微软雅黑;
    }

    .p1 {
        padding-left: 18px;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        color:#545754;
        border-bottom: 1px solid #e7e7e7;
    }

    .p2 {
        height: 65px;
        font-size: 15px;
        padding-left: 5px;
    }

    .margintop1 div {
        margin-top: 9px;
    }

    .p3 {
        height: 65px;
        border-bottom: 1px solid #e7e7e7;
    }

    .p3 span {
        margin-left: 920px;
    }

    .margintop1 {
        margin-left: 100px;
    }


</style>
<script>
  import {formatDate} from '../../common/date';

  export default {
    data() {
      return {
        dialogVisible: false,
        pic: '',
        url: [],
        pickerOptions0: {},
        detailData: [],
        itemList: [],
        active: true,
        num: 554,
        nowtime: formatDate(Date.now(), 'yyyy-MM-dd'),
      }
    },
    mounted: function () {
      let instoreID = this.$route.query.id;
      this.axios(instoreID);
    },
    methods: {
      openpic: function (val) {
        this.dialogVisible = true
        this.pic = val;
      },
      axios: function (k) {
        if (k) {
          this.$axios({
            url: '/api/medicine/instore/' + k,
            method: 'GET',
          }).then(res => {
            this.detailData = res.data.data;
            this.itemList = res.data.data.inStoreDetailsResponses
            this.url = JSON.parse(res.data.data.invoice);
          }).catch(err => {
            console.log(err.data);

          })
        }

      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";
        }
      },

      back: function () {
        this.$router.push({path: "./intoHouse"});
      }
    },


  }
</script>



// WEBPACK FOOTER //
// check.vue?73209bd2